import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { rememberSignupCta } from "@/lib/membership";

const MESSAGES = [
  { cta: "feed_per_te", t: "Vuoi un Readoo più personale?", d: "Scegli i tuoi interessi e costruisci il tuo feed.", b: "Crea il tuo Readoo" },
  { cta: "salva", t: "Leggi adesso, ritrova dopo.", d: "Registrati per salvare le notizie che ti interessano.", b: "Registrati gratis" },
  { cta: "founder", t: "Entra nella prima community Readoo.", d: "Diventa Founder e sarai tra i primi a scoprire le prossime novità.", b: "Diventa Founder" },
];

// Invito discreto alla registrazione tra i blocchi della home: un messaggio alla volta, alternato.
export function RegisterNudge() {
  const { user, loading } = useAuth();
  const { loginEnabled } = useSettings();
  const m = useMemo(() => MESSAGES[Math.floor(Math.random() * MESSAGES.length)], []);
  if (loading || user || !loginEnabled) return null;
  return (
    <aside data-testid="register-nudge" data-variant={m.cta} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-2xl border border-hair border-l-4 border-l-brand bg-surfaceSecondary px-5 py-4">
      <div>
        <p data-testid="register-nudge-title" className="font-serif text-lg font-semibold text-onSurface">{m.t}</p>
        <p className="text-sm text-subtle">{m.d}</p>
      </div>
      <Link to="/registrati" onClick={() => rememberSignupCta(m.cta)} data-testid="register-nudge-cta"
        className="group shrink-0 inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full border border-brand text-brand text-xs font-bold uppercase tracking-wide hover:bg-brand hover:text-onBrand transition-colors">
        {m.b} <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" />
      </Link>
    </aside>
  );
}
